module.exports = __webpack_public_path__ + "img/chatting.dcd87fea.png";